
  import { Component, Vue ,Model,Watch,Prop} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Dialog from './dialog.vue';
  import {
    activityCouponactivityCouponPageInit,
  } from "@/api/finance"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    @Model('change') show!:boolean
    @Prop({default:[]}) data!:any
    @Prop({default:0}) maxchoose!:number//最多选择数量 0表示无限
    @Prop({default:undefined}) ActivityRangeType!:number//商品详情那边用的['全场可用:0' or '指定参加商品条件:1' or '指定参加商品:2' or '指定不参加商品条件:3' or '指定不参加商品:4']
    private dialogshow = false
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private chooselist:any = []
    private pageNo = 1
    private pageSize = 10
    private total = 0
    private isfirst =false

    @Watch('show')
    private getshow(e){
      this.isfirst = e
      this.dialogshow = e
      if(e){
        this.pageNo = 1
        this.chooselist = this.data
        this.gettablelist()
      }
    }

    private mounted () {
      this.isfirst = true
      this.chooselist = this.data
    }


    private confirm(){
      if(!this.chooselist||!this.chooselist.length){
        this.$message.error('请选择优惠券')
        return
      }
      if(this.chooselist.length>this.maxchoose&&this.maxchoose!=0){
        this.$message.error(`最多添加${this.maxchoose}张优惠券`)
        return
      }
      this.$emit('getData',this.chooselist)
    }
    private selectionChange(list){
      // console.log(list)
      this.chooselist = list
      if(this.chooselist.length>this.maxchoose&&this.maxchoose!=0){
        this.$message.error(`最多添加${this.maxchoose}张优惠券`)
      }
    }
    private doSearch(){
      this.changePage(1)
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await activityCouponactivityCouponPageInit({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          ActivityRangeType:this.ActivityRangeType
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
          if(!this.dialogshow||!this.isfirst) return
          this.$nextTick(()=>{
            this.chooselist.map(v=>{
              (this as any).$refs.table.toggleRowSelection(v,true);
            })
            this.gettablelist()
            this.isfirst = false
          })
        }
      }finally{
        this.tableloading = false
      }
    }
    private close(){
      this.dialogshow = false
      this.$emit('close')
    }
  }
